import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Sri Lankan National ID validator following Single Responsibility Principle
 */
export class LkValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Sri Lankan National ID',
      pattern: /^\d{9}[VX]|\d{12}$/i,
      minLength: 10,
      maxLength: 12
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    if (upperCaseId.length < this.config.minLength || upperCaseId.length > this.config.maxLength) {
      return ValidationResult.invalid('Sri Lankan NID must be 10 or 12 characters');
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'Sri Lankan NID format must be XXXXXXXXXV/X or XXXXXXXXXXXX'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    
    if (upperCaseId.length === 10) {
      // Old format: 9 digits + V/X
      const digits = upperCaseId.substring(0, 9);
      const checkChar = upperCaseId[9];
      
      // Basic validation - V for normal, X for special cases
      if (checkChar !== 'V' && checkChar !== 'X') {
        return ValidationResult.invalid('Invalid check character - must be V or X');
      }
    } else if (upperCaseId.length === 12) {
      // New format: 12 digits
      // Basic structure validation
      const year = upperCaseId.substring(0, 4);
      const dayOfYear = upperCaseId.substring(4, 7);
      
      if (parseInt(year) < 1900 || parseInt(year) > 2100) {
        return ValidationResult.invalid('Invalid birth year');
      }
      
      if (parseInt(dayOfYear) < 1 || parseInt(dayOfYear) > 366) {
        return ValidationResult.invalid('Invalid day of year');
      }
    }

    return ValidationResult.valid('Valid Sri Lankan NID');
  }
}